import InvestmentFunnel from './InvestmentFunnel'

export default InvestmentFunnel
